/** What the app reads to find portraits and minor marks. */
export interface PortraitIndex {
  files: string[];
  minorIds?: string[];
  /** File name to its permanent address, when portraits are served from Cloudflare. */
  paths?: Record<string, string>;
}

/** With images switched off, the app finds none and falls back to colored discs. */
export function withoutImages(index: PortraitIndex): PortraitIndex {
  return { files: [], ...(index.minorIds === undefined ? {} : { minorIds: index.minorIds }) };
}

export function publishedPortraitPaths(
  bookId: string,
  hashes: ReadonlyMap<string, string>,
): Record<string, string> {
  return Object.fromEntries(
    [...hashes].map(([file, hash]) => [file, `${bookId}/${hash}/${file}`]),
  );
}

/** Where to read a book's index: Cloudflare when configured, otherwise beside the app. */
export function portraitIndexUrl(bookId: string, base: string | undefined): string {
  return base
    ? `${base.replace(/\/$/, "")}/${bookId}/index.json`
    : `/book-data/${bookId}/characters/index.json`;
}

/** Full image addresses for attachPortraits, or undefined when images sit beside the app. */
export function portraitUrls(
  index: PortraitIndex,
  base: string | undefined,
): Record<string, string> | undefined {
  if (!base || index.paths === undefined) {
    return undefined;
  }
  const root = base.replace(/\/$/, "");
  return Object.fromEntries(
    Object.entries(index.paths).map(([file, key]) => [file, `${root}/${key}`]),
  );
}
